<!--<div class="suggestion-actions" *ngIf="originalList" (click)="toggleActivityLock()" matRipple-->
<!--     [ngClass]="{'locked-activity': activity.lockedActivity}"-->
<!--     [matRippleCentered]="true">-->
<!--  <i class="pi {{activity.lockedActivity ? 'pi-lock' : 'pi-lock-open'}}"></i>-->
<!--</div>-->

<div class="suggestion-title" (click)="openProjectWindow()">
  <span class="project-name">{{activity.project.name}}</span>
  <span class="project-location">{{activity.project.location}}</span>
</div>
<div class="suggestion-date-buttons">
  <button class="date-button" [ngClass]="{'chosen-date': activity.isDateLock}" mat-button
          (click)="chooseOriginalDate()">{{activity.startDate | date: 'MMM dd'}}

    <i class="pi pi-check" *ngIf="activity.isDateLock"></i>
  </button>
  <i class="pi pi-arrow-right"></i>
  <button class="date-button" [ngClass]="{'chosen-date': !activity.isDateLock}" mat-button
          (click)="chooseSuggestedDate()">{{activity.suggestedStartDate | date: 'MMM dd'}}
    <i class="pi pi-check" *ngIf="!activity.isDateLock"></i>
  </button>
</div>
<div class="suggestion-activity-type" [style.background-color]="'#' + activity.type.color">
  {{activity.type.shortCode}}
</div>
